/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reach_Out_WhatsappInputs */

const en_reach_out_whatsapp = /** @type {(inputs: Reach_Out_WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Or reach out instantly on WhatsApp`)
};

const es_reach_out_whatsapp = /** @type {(inputs: Reach_Out_WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O contáctanos al instante por WhatsApp`)
};

const fr_reach_out_whatsapp = /** @type {(inputs: Reach_Out_WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ou contactez-nous instantanément sur WhatsApp`)
};

const de_reach_out_whatsapp = /** @type {(inputs: Reach_Out_WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oder erreiche uns sofort über WhatsApp`)
};

const id_reach_out_whatsapp = /** @type {(inputs: Reach_Out_WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atau hubungi langsung di WhatsApp`)
};

/** @type {(inputs: Reach_Out_WhatsappInputs) => LocalizedString} */
const ja_reach_out_whatsapp = en_reach_out_whatsapp;

/** @type {(inputs: Reach_Out_WhatsappInputs) => LocalizedString} */
const zh_reach_out_whatsapp = en_reach_out_whatsapp;

/** @type {(inputs: Reach_Out_WhatsappInputs) => LocalizedString} */
const ar_reach_out_whatsapp = en_reach_out_whatsapp;

/** @type {(inputs: Reach_Out_WhatsappInputs) => LocalizedString} */
const it_reach_out_whatsapp = en_reach_out_whatsapp;

/** @type {(inputs: Reach_Out_WhatsappInputs) => LocalizedString} */
const ru_reach_out_whatsapp = en_reach_out_whatsapp;

/** @type {(inputs: Reach_Out_WhatsappInputs) => LocalizedString} */
const pt_reach_out_whatsapp = en_reach_out_whatsapp;

/** @type {(inputs: Reach_Out_WhatsappInputs) => LocalizedString} */
const ko_reach_out_whatsapp = en_reach_out_whatsapp;

/**
* | output |
* | --- |
* | "Or reach out instantly on WhatsApp" |
*
* @param {Reach_Out_WhatsappInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const reach_out_whatsapp = /** @type {((inputs?: Reach_Out_WhatsappInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reach_Out_WhatsappInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reach_out_whatsapp(inputs)
	if (locale === "es") return es_reach_out_whatsapp(inputs)
	if (locale === "fr") return fr_reach_out_whatsapp(inputs)
	if (locale === "de") return de_reach_out_whatsapp(inputs)
	if (locale === "ja") return ja_reach_out_whatsapp(inputs)
	if (locale === "zh") return zh_reach_out_whatsapp(inputs)
	if (locale === "ar") return ar_reach_out_whatsapp(inputs)
	if (locale === "id") return id_reach_out_whatsapp(inputs)
	if (locale === "it") return it_reach_out_whatsapp(inputs)
	if (locale === "ru") return ru_reach_out_whatsapp(inputs)
	if (locale === "pt") return pt_reach_out_whatsapp(inputs)
	return ko_reach_out_whatsapp(inputs)
});